import * as React from "react";
import {ChangeEvent, useEffect, useState} from "react";
import {AutoComplete, Icon} from "antd";
import {Select, Spin} from "antd";
import {geocode} from "../../http/requestGeocoder";
const Option = AutoComplete.Option;

interface IProps {
    onSelectAddress: (coordinates: number[]) => void;
    onClearAddress: () => void;
}

export const GeocoderInput = React.memo(GeocoderInputComponent);

function GeocoderInputComponent (props: IProps) {
    const [fetching, setFetching] = useState(false);
    const [features, setFeatures] = useState([]);
    const [value, setValue] = useState(undefined);
    const [selectedValue, setSelectedValue] = useState(undefined);
    const [options, setOptions] = useState([]);
    const onSearch: any = React.useCallback(async (event: KeyboardEvent) => {
        if (!event.target) return;
        const search = (event.target as HTMLInputElement).value;
        setFetching(true);
        const features = await geocode(search);
        setFetching(false);
        const featuresText = features.map((f: any, i: number) =>
            <Option key={`${i}_${f.text}`} value={`${i}`} title={f.text}>
                    {f.text}
            </Option>
        );
        setOptions(
            (!search || search.length === 0) ? [] : featuresText,
        );
        setFeatures(features);
    }, [setOptions, setFeatures, setFetching]);

    const onChange = React.useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setValue(e as any);
    }, [setValue])

    const onSelect = React.useCallback((index: number) => {
        const f = features[index];
        const {text, lon, lat} = f;
        setValue(text);
        setSelectedValue(text);
        setOptions([]);
        props.onSelectAddress([lon, lat]);
    }, [features, setValue, setOptions, props]);

    const onKeyDown =  React.useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        switch (e.which) {
            // up
            case 38:
                // e.preventDefault();
                // this.moveFocus(-1);
                break;
            // down
            case 40:
                // this.moveFocus(1);
                break;
            // accept
            case 13: // enter
                onSearch(e);
                break;
        }
    }, [onSearch]);

    const handleSuffixClick = React.useCallback(() => {
        setValue(undefined);
        setSelectedValue(undefined);
        setOptions([]);
        if (props.onClearAddress) props.onClearAddress();
    }, [setValue, setOptions, props])

    // const handleOutsideClick = React.useCallback((e: MouseEvent): void => {
    //     if ((typeof value === 'undefined') || options.length === 0) return;
    //     // if (className === 'overlays' ||
    //     //     className === 'ant-select-selection-selected-value' ||
    //     //     className === 'mapContainer') {
    //     setValue(selectedValue);
    //     setOptions([]);
    //     // }
    // }, [setValue, setOptions, options, value, selectedValue])

    useEffect(() => {
        const handleOutsideClick = (e: MouseEvent): void => {
            if ((typeof value === 'undefined') || options.length === 0) return;
            // if (className === 'overlays' ||
            //     className === 'ant-select-selection-selected-value' ||
            //     className === 'mapContainer') {
            setValue(selectedValue);
            setOptions([]);
            // }
        }

        document.body.addEventListener('click', handleOutsideClick);
        return () => document.body.removeEventListener('click', handleOutsideClick);
    }, [setValue, setOptions, value, selectedValue, options])

    // @ts-ignore
    return <Select
            mode="default"
            className={'user-select'}
            showSearch={true}
            suffixIcon={<Icon type={(!value || value === '') ? 'search' : 'close'} onClick={handleSuffixClick}/>}
            value={value}
            placeholder="Search Address"
            notFoundContent={fetching ? <Spin size="small" /> : null}
            filterOption={false}
            onSearch={() => {}}
            onInputKeyDown={onKeyDown}
            onChange={onChange}
            //@ts-ignore
            onSelect={onSelect}
            children={options}
            style={{ width: 400 }}/>;
}
